var map = {
	"./2018/config.json": [
		319,
		4
	],
	"./2019/config.json": [
		321,
		6
	],
	"./2020/config.json": [
		323,
		8
	],
	"./2021/config.json": [
		325,
		10
	],
	"./2022/config.json": [
		327,
		12
	],
	"./2023/config.json": [
		329,
		14
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 580;
module.exports = webpackAsyncContext;